import React from 'react'
// import glamorous from 'glamorous'

/* eslint-disable-next-line import/no-named-as-default */
import Default from '../layouts/default'
import {P, I, A, Strong} from '../components/common'

const About = ({location}) => (
  <Default location={location}>
    <P css={{textAlign: 'center'}}>🎓 OPRF → DVC → UCD </P>
    <P css={{textAlign: 'center'}}>💻 iOS → Backend → React </P>
    <P css={{textAlign: 'center'}}>
      🏡 CHI → SF → BOS → CHI → SF → NYC → SF
      <I css={{display: 'block', fontSize: '0.5rem'}}>I've actually moved this many times.</I>
    </P>
    <P>
      I'm obsessed with finding <Strong>hard problems</Strong> to work on, like directing the {` `}
      <A href="https://calhacks.io" target="_blank" rel="noopener noreferrer">
        largest hackathon
      </A>{' '}
      with 2,000+ attendees over 36 hours, creating a {` `}
      <A href="https://tulip.co" target="_blank" rel="noopener noreferrer">
        real-time analytics engine
      </A>{' '}
      for the factory floor, or making acessible {` `}
      <A href="https://keybase.io" target="_blank" rel="noopener noreferrer">
        encryption for everyone
      </A>.
    </P>

    <P>
      Naturally I end up applying <Strong>functional programming</Strong> {` `}
      concepts to hard problems and enjoy the benefits of purity and simplicity. Some of my favorite languages
      are <Strong>Elixir</Strong> {` `}
      , {` `}
      <Strong>Rust</Strong> {` `}
      , and {` `}
      <Strong>ReasonML</Strong>
      .{` `}
    </P>

    <P>
      Between professional work and school work, I advocate strongly for using {` `} "
      <a href="https://www.saffo.com/02008/07/26/strong-opinions-weakly-held/">
        <Strong>Strong Opinions, Weakly Held</Strong>
      </a>
      "{` `} as a framework for thinking. This is something that my Engineering Manager at Braintree imparted
      on me, which helped reframe and apply some strong thoughts I had regarding Software Egnineering.
    </P>

    <P>
      <A
        href="https://jacobyoung.keybase.pub/jacob-young-resume.pdf?"
        target="_blank"
        rel="noopener noreferrer"
      >
        Résumé
      </A>
    </P>
  </Default>
)

export default About
